import { z } from "zod";
import { PublicMeetingSchema } from "../../models/meeting.schema";

export const MeetingControllerResponseSchema = {
  listPublicMeetings: PublicMeetingSchema.array(),

  getPublicMeeting: PublicMeetingSchema.nullable(),

  getMeetingAgendaPdf: z.void().nullable(),
};
